import React from "react";
import "./Eligibility.css";

const EligibilityPreview = ({ previewService, setShowPreviewEligibility }) => {
    if (!previewService) return null;

    const { title, heading, description } = previewService;

    return (
        <div className="elig-overlay" onClick={() => setShowPreviewEligibility(false)}>
            <div
                className="elig-page-preview"
                onClick={(e) => e.stopPropagation()}
            >
                {/* CLOSE */}
                <button
                    className="elig-close"
                    onClick={() => setShowPreviewEligibility(false)}
                >
                    ✕
                </button>

                {/* HERO SECTION */}

                <div className="service-preview-header">
                    <h1>Check Eligibility</h1>
                    <p>
                        Home <span>&gt;</span> <span className="about-preview-subtitle">Check Eligibility</span>
                    </p>
                </div>


                {/* BODY CONTENT */}
                <div className="elig-body">
                    <span className="elig-tag">{title}</span>

                    <h2 className="elig-heading">{heading}</h2>

                    <div
                        className="elig-description"
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                </div>
            </div>
        </div>
    );
};

export default EligibilityPreview;
